import styled from "styled-components"

import {H4} from "@irati/ui/src/Headings"
import {greys, perkbox} from "@irati/ui/src/global/colors"
import {Para} from "@irati/ui/src/Labels"
import Icon from "@irati/ui/src/Icon"

export const SIDEBAR_INDENT = "50px"
const SIDEBAR_DIVIDER = `1px solid ${greys.light};`
export const SIDEBAR_WIDTH = "350px"

export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 80px);
  width: ${SIDEBAR_WIDTH};
  min-width: ${SIDEBAR_WIDTH};
  overflow-y: hidden;
  z-index: 15;
  background-color: ${greys.lightest};
`

export const SideBarHeader = styled.div`
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
`

export const SideBarMainContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-evenly;
  overflow-y: auto;
`

export const SideBarFooter = styled.div`
  min-height: 60px;
  padding: 5px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px 15px;
  border: ${SIDEBAR_DIVIDER};
  cursor: pointer;
`

export const SectionTitle = styled(H4)`
  padding: 10px 5px 10px ${SIDEBAR_INDENT};
  border-top: ${SIDEBAR_DIVIDER};
  border-bottom: ${SIDEBAR_DIVIDER};
  text-transform: lowercase;

  &:first-letter {
    text-transform: capitalize;
  }
`

export const SectionContent = styled.div`
  padding: 10px 0;
`

interface StepLinkContainerProps {
  active?: boolean
}
export const StepLinkContainer = styled.div<StepLinkContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  padding-left: ${SIDEBAR_INDENT};
  cursor: pointer;
  ${({active}: StepLinkContainerProps) => active && `background-color: ${greys.light};`}
`

interface StepLabelProps {
  done?: boolean
}
export const StepNumberLabel = styled(Para)<StepLabelProps>`
  display: inline;
  ${({done}) => done && `color: ${perkbox.blue};`}
`

export const StepNumberContainer = styled.div`
  width: 45px;
`

export const StepLabel = styled(Para)<StepLabelProps>`
  display: flex;
  flex-grow: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${({done}) => done && "text-decoration: line-through;"}
  ${({done}) => done && `color: ${greys.mediumLight};`}
`

export const MarginIcon = styled(Icon)`
  margin-right: 20px;
`

export const TopArrow = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  top: -11px;
  right: 100px;
  border-top: 1px solid ${perkbox.blue};
  border-left: 1px solid ${perkbox.blue};
  background-color: #7acdef;
  transform: rotate(45deg);
`
